module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoMjQsIDE0NCwgMjU1LCAxKSI+CiAgICA8cGF0aCBkPSJNMCAwaDQ4djQ4SDB6IiBmaWxsPSJub25lIj48L3BhdGg+CiAgICA8cGF0aCBkPSJNMjQgNEMxMi45NiA0IDQgMTIuOTUgNCAyNHM4Ljk2IDIwIDIwIDIwIDIwLTguOTUgMjAtMjBTMzUuMDQgNCAyNCA0em0yIDMwaC00di00aDR2NHptMC04aC00VjE0aDR2MTJ6Ij48L3BhdGg+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/prompts/plaint.svg
// module id = Edl8
// module chunks = 3